import React, {useState, useRef} from 'react';
import {DeviceType} from '../EsimEnum';
import {prepareNewWindowUrl} from '../../../../utilities/StringHelpers/StringHelpers.js';
import {getVideoLink} from '../../../../utilities/ImageProps';
import ReactPlayer from 'react-player';

import androidImage from '../EsimIcons/icon-24-android.svg';
import androidImageGrey from '../EsimIcons/icon-24-android-grey.svg';
import IOSImage from '../EsimIcons/icon-24-apple.svg';
import IOSImageGrey from '../EsimIcons/icon-24-apple-grey.svg';

const TutorialEsim = (props) => {
  const videoUrlAndroid = getVideoLink(props.iContent?.videoUrlAndroid, props.context);
  const videoUrlIos = getVideoLink(props.iContent?.videoUrlIos, props.context);
  const instructionsAndroid = props.iContent.instructionsUrlAndroid?.value;
  const instructionsIos = props.iContent.instructionsUrlIos?.value;

  const devices = [
    {
      displayName: 'אנדרואיד',
      deviceType: DeviceType.Android,
      videoUrl: videoUrlAndroid ? videoUrlAndroid : null,
      instructions: instructionsAndroid,
      image: androidImage,
      imageGrey: androidImageGrey,
      style: {
        menuItem: {
          paddingLeft: 'unset',
        },
      },
    },
    {
      displayName: 'IOS',
      deviceType: DeviceType.IOS,
      videoUrl: videoUrlIos ? videoUrlIos : null,
      instructions: instructionsIos,
      image: IOSImage,
      imageGrey: IOSImageGrey,
      style: {
        menuItem: {
          paddingLeft: '30px',
        },
      },
    },
  ];

  const [selectedDevice, setSelectedDevice] = useState(devices[0]);
  const isPopUp = useRef(props.isPopUp);

  const navigateToInstructions = async (link) => {
    prepareNewWindowUrl(link, props.context);
  };

  const onSelectDevice = (device) => {
    if (selectedDevice.deviceType != device.deviceType) {
      setSelectedDevice(device);
    }
  };
  return (
    <div className='tutorialEsim'>
      <div className='tutorialEsim__header'>
        <h1>{props.iContent.tutorialPageMainTitle?.value}</h1>
        <h2>{props.iContent.tutorialPageSecondTitle?.value}</h2>
      </div>
      <div className='tutorialEsim__body'>
        <div className='tutorialEsim__body__toggleMenu'>
          {devices.map((item) => {
            return (
              <>
                <div className='tutorialEsim__body__toggleMenu__item' style={item.style.menuItem} onClick={() => onSelectDevice(item)}>
                  <div
                    className='tutorialEsim__body__toggleMenu__item__image'
                    style={{
                      backgroundImage: 'url(' + (selectedDevice.deviceType == item.deviceType ? item.image : item.imageGrey) + ')',
                    }}></div>
                  <div className='tutorialEsim__body__toggleMenu__item__displayName'>
                    {selectedDevice.deviceType == item.deviceType ? (
                      <div className='selected'>{item.displayName}</div>
                    ) : (
                      <div>{item.displayName}</div>
                    )}
                  </div>
                </div>

                {item.deviceType == DeviceType.Android ? (
                  <>
                    <div className='tutorialEsim__body__toggleMenu__item__split'></div>
                  </>
                ) : (
                  <></>
                )}
              </>
            );
          })}
        </div>

        <div className='tutorialEsim__body__container'>
          <div className='video-wrapper'>
            {selectedDevice.deviceType == DeviceType.Android ? (
              <ReactPlayer
                className='react-player'
                playsinline
                url={devices[0].videoUrl}
                volume={1}
                muted={false}
                controls
                style={{width: 'unset', height: '100%', objectFit: 'cover', borderRadius: '11px'}}
                playing={false}
              />
            ) : (
              <ReactPlayer
                className='react-player'
                playsinline
                url={devices[1].videoUrl}
                volume={1}
                muted={false}
                controls
                style={{width: 'unset', height: '100%', objectFit: 'cover', borderRadius: '11px'}}
                playing={false}
              />
            )}
          </div>
          <p className='instructions-text'>
            <span>מעדיפים הוראות התקנה?</span>
            <span className='underVideoText' onClick={() => navigateToInstructions(selectedDevice.instructions)}>
              לחצו כאן
            </span>
          </p>
        </div>
      </div>
      <div className='split'></div>
      <div className='tutorialEsim__bottom'>
        <div className={isPopUp.current ? 'messageContainer' : 'messageContainer messageMarked'}>
          <h1>שימו לב!</h1>
          <p className='message'>{props.iContent.tutorialPageWifiText?.value}</p>
        </div>

        {props.footerButton != null ? <div className='footerButton'>{props.footerButton}</div> : <></>}
      </div>
    </div>
  );
};

export default TutorialEsim;
